import { Grid, Typography } from "@mui/material";
import React from "react";
import IRatingAnalytics, { IStars } from "../../interface/iRatingAnalytics";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";

const RenderCategoryContent = (): React.JSX.Element => {
  const {
    ratingAnalytics,
  }: {
    ratingAnalytics: IRatingAnalytics;
  } = React.useContext(RatingOverviewContext);

  return (
    <Grid container spacing={1}>
      {Object.keys(ratingAnalytics).map((key) => {
        const stars: IStars = ratingAnalytics[
          key as keyof IRatingAnalytics
        ] as IStars;

        if (key === "topics") return null;
        if (key === "total") return null;

        return (
          <React.Fragment key={key}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="initial">
                {stars.titel}
              </Typography>
            </Grid>

            {[
              stars.star1,
              stars.star2,
              stars.star3,
              stars.star4,
              stars.star5,
              stars.average,
            ].map((starValue: number, starIndex: number) => (
              <Grid
                key={starIndex}
                item
                xs={12}
                sm={1}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" color="initial">
                  {starValue}
                </Typography>
              </Grid>
            ))}
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default RenderCategoryContent;
